import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

import InputRow from '../../../Components/InputRow';

export default class Row extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isEditing: false,
			name: props.name,
			shortname: props.shortname,
		};
	}

	componentWillReceiveProps = nextProps => {
		this.setState({
			name: nextProps.name,
			shortname: nextProps.shortname,
		});
	};

	validateInput = () => {
		const { name, shortname } = this.state;
		if (name.trim() !== '' && shortname.trim() !== '') {
			return true;
		}

		return false;
	};

	handleInputChange = (name, value) => {
		this.setState({
			[name]: value,
		});
	};

	toggleMode = () => {
		this.setState({
			isEditing: !this.state.isEditing,
		});
	};

	confirmChange = () => {
		if (this.validateInput()) {
			this.setState({
				isEditing: false,
			});

			this.props.confirmChange(this.state.name, this.state.shortname);
		} else {
			toast.warn('กรุณากรอกข้อมูลในครบ');
		}
	};

	cancelChange = () => {
		this.setState({
			name: this.props.name,
			shortname: this.props.shortname,
			isEditing: false,
		});
	};

	delete = () => {
		this.props.confirmDelete(this.props.id);
	};

	render() {
		if (this.state.isEditing) {
			return (
				<div className="columns">
					<div className="column is-3">
						<InputRow
							labelSize="s"
							title="ชื่อเต็ม"
							placeholder="ชื่อเต็ม"
							keyProps="name"
							value={this.state.name}
							onInputChange={this.handleInputChange}
							disabled={false}
						/>
					</div>
					<div className="column is-3">
						<InputRow
							labelSize="s"
							title="ชื่อย่อ"
							placeholder="ชื่อย่อ"
							keyProps="shortname"
							value={this.state.shortname}
							onInputChange={this.handleInputChange}
							disabled={false}
						/>
					</div>
					<div className="column is-3 buttons has-addons is-centered" style={{ paddingTop: 45 }}>
						<button type="button" className="button is-success" onClick={this.confirmChange}>
							{this.props.confirmText ? this.props.confirmText : 'แก้ไข'}
						</button>
						{this.props.confirmDelete ? (
							<button type="button" className="button is-danger" onClick={this.delete}>
								{this.props.deleteText ? this.props.deleteText : 'ลบ'}
							</button>
						) : null}
						<button type="button" className="button" onClick={this.cancelChange}>
							ยกเลิก
						</button>
					</div>
				</div>
			);
		} else {
			return (
				<div onClick={this.toggleMode} className="clickable">
					{this.props.children}
				</div>
			);
		}
	}
}
